export const ZOOM_STEP = 10;
export const ZOOM_MIN = 20;
export const ZOOM_MAX = 500;

export const DOCUMENT_STATUS = {
	IN_PROGRESS: "IN_PROGRESS",
	COMPLETED: "COMPLETED",
	PENDING: "PENDING",
	TIMEOUT: "TIMEOUT",
	FAILED: "FAILED",
	NOT_MANAGED: "NOT_MANAGED",
};
export const VERSIONING_STATUS = {
	VALIDATED: "VALIDATED",
	DISCARDED: "DISCARDED",
	CREATED: "CREATED",
};
